import { createTheme } from "@dash/default-theme";
import { Theme, ThemeProvider } from "@emotion/react";
import { ReportPage, ReportsPage } from "@megarax/analytics-reports";
import { MegaraxWebappContainer } from "@megarax/features";
import { MdInsights } from "react-icons/md";
import { Navigate, Outlet, Route } from "react-router-dom-v5-compat";

import { getMegaraxPath } from "@megaron/megarax-uri";

const analyticsTheme: Theme = createTheme("252");

export const useAnalyticsRouter = () => {
  return (
    <Route
      path="/analytics"
      element={
        <ThemeProvider theme={analyticsTheme}>
          <AnalyticsWebappContainer />
        </ThemeProvider>
      }
    >
      <Route path="" element={<Navigate to={getMegaraxPath.uri("megarax://analytics/reports")} replace />} />
      <Route path="reports">
        <Route path="" element={<ReportsPage />} />
        <Route path="id/:reportId" element={<ReportPage />} />
      </Route>
    </Route>
  );
};

const AnalyticsWebappContainer: React.FC = () => {
  return (
    <MegaraxWebappContainer logo={<MdInsights width="1em" height="1em" />} title="Analityka" subtitle="Megarax.net">
      <Outlet />
    </MegaraxWebappContainer>
  );
};
